import React from "react";
import { useI18n } from "../../lib/i18n.jsx";

const FLORA_AVATAR = "https://i.imgur.com/cnBBwDr.png";

export default function FloraSection({ onOpenFlora }) {
  const { t } = useI18n();
  const bullets = [t.flora.bullet1, t.flora.bullet2, t.flora.bullet3];

  return (
    <section
      id="flora"
      className="py-24 lg:py-32 bg-[#133322] text-[#f7f7f4] relative overflow-hidden"
      data-testid="flora-section"
    >
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#b45f3e]/30 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#9ead9b]/20 blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="aspect-square rounded-2xl overflow-hidden relative">
              {/* Animated aura behind the avatar */}
              <span className="eu-flora-aura" aria-hidden="true"></span>
              <img
                src={FLORA_AVATAR}
                alt="Flora AI"
                className="w-full h-full object-cover relative z-10"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#133322]/60 via-transparent to-transparent z-10" />
            </div>

            <div className="absolute -top-4 -right-4 bg-[#f7f7f4] text-[#133322] rounded-2xl p-4 shadow-xl w-[200px]">
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="eu-data-label text-[#133322]">ONLINE 24/7</span>
              </div>
              <div className="mt-2 font-display text-xl">Flora</div>
              <div className="text-xs text-[#5c6b61]">AI Agronomist</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="eu-data-label text-[#9ead9b] mb-6">
            <i className="fa-solid fa-wand-magic-sparkles mr-2"></i>
            {t.flora.eyebrow}
          </div>
          <h2 className="font-display text-5xl lg:text-6xl text-[#f7f7f4] leading-[1.05] tracking-tight">
            {t.flora.title}
          </h2>
          <p className="mt-4 text-xl text-[#9ead9b] italic font-display">
            {t.flora.subtitle}
          </p>
          <p className="mt-8 text-base lg:text-lg text-[#f7f7f4]/80 leading-relaxed max-w-2xl">
            {t.flora.description}
          </p>

          <ul className="mt-10 space-y-3">
            {bullets.map((b, i) => (
              <li
                key={i}
                className="flex items-start gap-3"
                data-testid={`flora-bullet-${i}`}
              >
                <i className="fa-solid fa-leaf text-[#b45f3e] mt-1.5"></i>
                <span className="text-[#f7f7f4]/90">{b}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={onOpenFlora}
            className="mt-10 inline-flex items-center gap-2 bg-[#f7f7f4] text-[#133322] rounded-full px-7 py-3.5 font-medium hover:bg-[#b45f3e] hover:text-[#f7f7f4] transition-all"
            data-testid="flora-section-cta"
          >
            <i className="fa-solid fa-comment-dots"></i>
            {t.flora.cta}
          </button>
        </div>
      </div>
    </section>
  );
}
